import React from "react";

import ReviewInfoClinica from "./ReviewInfoClinica";

import translator from "../../../../utilities/translator";
import { examStatusToString } from "../../../../logic/utilsClinical.js";
import { useSelector, useDispatch } from "react-redux";
import ExamStatusEnum from "../../../../logic/ExamStatusEnum";

import { InfoClinicaSVG } from "../SVGs";

export default function ReviewTopMenuContent({
	institution,
	patHistoryExams,
	bundledExams,
	mainExam,
	showReport,
	associatedReport,
	patient,
	compareStudies,
	setCompareStudies,
	showImages,
}) {
	const token = useSelector((state) => state.session.token);
	let currentState = window.history.state;
	const { openInfoClinica } = currentState || {};
	const currentLanguage = useSelector(
		(state) => state.session.userPreferences?.language
	);

	const userPreferences = useSelector(
		(state) => state?.session?.userPreferences
	);

	const [showInfoClinica, setShowInfoClinica] = React.useState(
		userPreferences?.examEditorClinicalInfoOpen ?? openInfoClinica ?? false
	);
	const [showExamHistory, setShowExamHistory] = React.useState(false);

	const toggler = (e, input) => {
		e.preventDefault();
		setShowInfoClinica(input === "showInfoClinica" ? !showInfoClinica : false);
	};

	React.useEffect(() => {
		if (compareStudies?.length > 0) {
			setShowInfoClinica(false);
		}
	}, [compareStudies]);

	const handleClickOutsidePanels = function (e) {
		if (e.target.localName === "div" || e.target.localName === "nav") {
			if (
				!document.getElementById("ClinicalInfoPanel")?.contains(e.target) &&
				document.getElementById("ClinicalInfoPanel")?.offsetParent !== null &&
				!userPreferences?.examEditorClinicalInfoOpen
			) {
				setShowInfoClinica(false);
			}
			if (
				!document.getElementById("ExamHistoryanel")?.contains(e.target) &&
				document.getElementById("ExamHistoryPanel")?.offsetParent !== null
			) {
				setShowExamHistory(false);
			}
		}
	};
	React.useEffect(() => {
		window.addEventListener("click", handleClickOutsidePanels);
		return () => {
			window?.removeEventListener("click", handleClickOutsidePanels);
		};
	}, []);

	return (
		<div
			className="div-divider mr-auto topfirst-sec"
			style={{ display: "flex", flex: "1" }}
		>
			<ul className="navbar-nav full-width " style={{ paddingRight: "1em" }}>
				{
					<li className="nav-item dropdown">
						<button
							title={translator(currentLanguage, "clinical_info")}
							className="btn btn-link nav-link dropdown-toggle primary-textcolor"
							onClick={async (e) => toggler(e, "showInfoClinica")}
							style={{
								background: showInfoClinica ? "#EBB994" : "#ffffff",
								border: "2px solid #e78e4b",
								borderRadius: "8px",
								padding: "4px 10px", // menor altura
								cursor: "pointer",
								display: "inline-flex",
								alignItems: "center",
								justifyContent: "center",
								transition: "all 0.2s",
								outline: "none",
								boxShadow: "0 4px 6px rgba(0,0,0,0.15)",
								position: "relative",
							}}
							onMouseOver={(e) => {
								if (!showInfoClinica) {
									e.currentTarget.style.background = "#EBB994";
									e.currentTarget.style.boxShadow =
										"0 6px 10px rgba(0,0,0,0.2)";
									e.currentTarget.style.transform = "translateY(-2px)";
								}
							}}
							onMouseOut={(e) => {
								if (!showInfoClinica) {
									e.currentTarget.style.background = "#fff";
									e.currentTarget.style.boxShadow =
										"0 4px 6px rgba(0,0,0,0.15)";
									e.currentTarget.style.transform = "translateY(0)";
								}
							}}
							onMouseDown={(e) => {
								e.currentTarget.style.transform = "translateY(1px) scale(0.95)";
								e.currentTarget.style.boxShadow = "0 2px 4px rgba(0,0,0,0.1)";
							}}
							onMouseUp={(e) => {
								e.currentTarget.style.transform = "translateY(-2px) scale(1)";
								e.currentTarget.style.boxShadow = "0 6px 10px rgba(0,0,0,0.2)";
							}}
						>
							<InfoClinicaSVG />
							<span style={{ marginLeft: "4px", fontSize: "0.9em" }}>
								{" "}
								{translator(currentLanguage, "clinical_info")}
							</span>
							<div
								style={{
									background: "orange",
									borderRadius: "1em",
									width: "1.5em",
									height: "1.5em",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
									position: "absolute",
									top: "-5px",
									right: "-5px",
									fontSize: "0.85em",
									color: "white",
									fontWeight: "bold",
								}}
							>
								{" "}
								{bundledExams ? bundledExams.length : 1}
							</div>
						</button>
					</li>
				}
			</ul>

			{bundledExams && mainExam && patHistoryExams && (
				<div
					id="ClinicalInfoPanel"
					style={{ display: showInfoClinica ? "block" : "none" }}
				>
					<ReviewInfoClinica
						institution={institution}
						bundledExams={bundledExams}
						mainExam={mainExam}
						associatedReport={associatedReport}
						patientDetails={patient}
						patHistoryExams={patHistoryExams}
						compareStudies={compareStudies}
						setCompareStudies={setCompareStudies}
						showImages={showImages}
					/>
				</div>
			)}
			<div style={{ flex: "0", minWidth: "2em", position: "relative" }}>
				{mainExam?.status === ExamStatusEnum.SIGNED && (
					<span
						title={examStatusToString(currentLanguage, mainExam)}
						className="zmdi-hc-stack zmdi-hc-lg "
						style={{ fontSize: "1.2em" }}
					>
						<i className="zmdi zmdi-file zmdi-hc-stack-2x active"></i>
						<i
							className="zmdi zmdi-check zmdi-hc-stack-1x"
							style={{ fontSize: "1.8em" }}
						></i>
					</span>
				)}

				{mainExam?.status !== ExamStatusEnum.SIGNED && (
					<i
						title={examStatusToString(currentLanguage, mainExam)}
						className="zmdi zmdi-book-image active"
						style={{ fontSize: "1.8em" }}
					></i>
				)}
			</div>
			{
				<div
					style={{
						fontSize: "14px",
						display: "flex",
						marginLeft: "1em",
						flexDirection: "row",
						minWidth: "300px",
						textTransform: "capitalize",
					}}
				>
					<div
						style={{
							display: "flex",
							flexDirection: "column",
							maxHeight: "40px",
							overflow: "hidden",
						}}
					>
						<div
							title={`${mainExam?.patFirstName?.toUpperCase()} ${mainExam?.patMiddleName?.toUpperCase()} ${mainExam?.patLastName?.toUpperCase()}`}
							style={{
								fontWeight: "bold",
								display: "flex",
								maxWidth: "100%",
							}}
						>
							<div>{`${mainExam?.patFirstName?.toUpperCase()}`}</div>
							<div style={{ overflow: "hidden", height: "21px" }}>
								&nbsp;{`${mainExam?.patMiddleName?.toUpperCase()}`}&nbsp;
							</div>
							<div>{`${mainExam?.patLastName?.toUpperCase()}`} </div>
						</div>
						<div style={{}}>{mainExam?.productName}</div>
						<div style={{}}> </div>
					</div>
					<div
						style={{
							display: "flex",
							fontWeight: "bold",
							marginLeft: "2em",
							flexDirection: "column",
						}}
					>
						<div className="color-green">
							<div style={{ width: "3em", float: "left" }}>
								{translator(currentLanguage, "pat_ident")}
							</div>
							<div style={{ width: "10em" }}>{mainExam?.patIdent} </div>
						</div>
						<div>
							<div style={{ width: "3em", float: "left" }}>EID</div>
							<div style={{ width: "10em" }}>{mainExam?.id} </div>
						</div>
					</div>
				</div>
			}
		</div>
	);
}
